import {Grid, GridItem} from "@consta/uikit/Grid";
import {Button} from "@consta/uikit/Button";
import React, {useEffect, useState} from "react";
import "../css/pageBsi.css";
import {DragNDropField} from '@consta/uikit/DragNDropField';
import {Text} from '@consta/uikit/Text';
import GridBsiBsiList from "./component/grid.bsi.bsiList";
import ModalBsiPayload, {readFile} from "./component/modal.bsi.payload";
import ModalBsiDiagram from "./component/modal.bsi.diagram";
import {Tabs} from "@consta/uikit/Tabs";
import {IconPhoto} from "@consta/uikit/IconPhoto";
import {IconRing} from "@consta/uikit/IconRing";
import {IconComponent} from "@consta/uikit/Icon";
import {SnackCmp} from "../../component/snack.cmp";
import {ProcessingType} from "./component/modal.bsi.payload";
import http from "../../service/axiosConfig";
import {
    API_BSI_AUTO_SOURCE_DIAGRAM,
    API_BSI_AUTO_DAILY_RUN,
    API_BSI_AUTO_DEVICES,
    API_BSI_AUTO_SESSION_CORRECT_WELL,
    API_BSI_AUTO_SESSION_LOAD,
    API_BSI_AUTO_SESSIONS,
    API_BSI_TEHSMART_ARCHIVE,
    API_BSI_TEHSMART_REFRESH,
    API_CONTRACTOR_CLOSURE_OPTIONS,
    API_DRAMATIQ_TASK_RESULT
} from "../../service/api.endpoint";

type Item = {
    name: string;
    image?: IconComponent;
};

const items: Item[] = [
    {
        name: "Загрузка",
        image: IconPhoto
    },
    {
        name: "Сервер",
        image: IconRing
    },
    {
        name: "Автозагрузка",
        image: IconRing
    }
];

const PageBsi = () => {
    const [tabsValue, setTabsValue] = useState<Item | null>(items[0]);
    const [files, setFiles] = React.useState<File[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalDiagramOpen, setIsModalDiagramOpen] = useState(false);
    const [newRowData, setNewRowData] = useState<any>(null);
    const [bsiFileDiagram, setBsiFileDiagram] = useState<string | null>();
    const [bsiDiagramFileName, setBsiDiagramFileName] = useState<string>('');
    const [isDiagramFileReading, setIsDiagramFileReading] = useState(false);
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [processingData, setProcessingData] = useState<ProcessingType[]>([]);

    useEffect(() => {
        document.title = 'АСПО.Контроль | БСИ';
    }, []);

    const handleModalClose = (value: any) => {
        setIsModalOpen(false);
        if (value && value !== false) {
            // value теперь это processingData (массив)
            if (Array.isArray(value) && value.length > 0) {
                setProcessingData(value);
                setShowSnackbar(true);
                setNewRowData(value); // Обновляем данные для таблицы

                // Скрываем снекбар через 4 секунды после последнего уведомления
                setTimeout(() => {
                    setShowSnackbar(false);
                    setProcessingData([]);
                }, 4000);
            }
        }
    };

    const handleDropFiles = (files: any) => {
        setFiles(files)
        setIsModalOpen(true)
    }

    const handleDropFilesDiagram = (files: any) => {
        const file = files?.[0]

        if (!file) {
            return
        }

        setBsiFileDiagram(null)
        setBsiDiagramFileName(file.name || '')
        setIsDiagramFileReading(true)
        setIsModalDiagramOpen(true)

        readFile(file)
            .then((contents: any) => {
                setBsiFileDiagram(contents)
            })
            .finally(() => setIsDiagramFileReading(false))
    }

    const handleModalDiagramClose = () => {
        setIsModalDiagramOpen(false);
        setBsiFileDiagram(null)
        setBsiDiagramFileName('')
        setIsDiagramFileReading(false)
    };


    return (
        <div className="bsi-page">
            <div className="bsi-page__header">
                <div>
                    <h1>БСИ</h1>
                    <p>Загрузка, проверка и просмотр данных по проходкам экипажей</p>
                </div>
                <div className="bsi-page__summary">
                    <span>TXT-файлы</span>
                    <strong>БСИ экипажей</strong>
                </div>
            </div>

            {tabsValue?.name === "Загрузка" &&
                (<Grid className="bsi-actions" cols="4" gap="m">
                    <GridItem col={2}>
                        <div className="bsi-upload-card">
                            <DragNDropField multiple={true}
                                            onDropFiles={(files) => handleDropFiles(files)}
                                            accept={['.txt']}>
                                {({openFileDialog}) => (
                                    <div className="bsi-drop-content">
                                        <div className="bsi-drop-icon">БСИ</div>
                                        <Text weight="black" size="l">
                                            Загрузить БСИ в систему
                                        </Text>
                                        <Text size="s" view="secondary">
                                            Перетащите один или несколько TXT-файлов экипажей. После проверки откроется окно подтверждения.
                                        </Text>
                                        <Button size='s' view="primary" onClick={openFileDialog} label="Выбрать файлы"/>
                                    </div>
                                )}
                            </DragNDropField>
                        </div>
                    </GridItem>
                    <GridItem col={2}>
                        <div className="bsi-upload-card bsi-upload-card--diagram">
                            <DragNDropField multiple={false}
                                            onDropFiles={(files) => handleDropFilesDiagram(files)}
                                            accept={['.txt']}>
                                {({openFileDialog}) => (
                                    <div className="bsi-drop-content">
                                        <div className="bsi-drop-icon bsi-drop-icon--diagram">График</div>
                                        <Text weight="black" size="l">
                                            Быстро открыть диаграмму
                                        </Text>
                                        <Text size="s" view="secondary">
                                            Для просмотра без загрузки в график выберите один TXT-файл БСИ.
                                        </Text>
                                        <Button size='s' view="secondary" onClick={openFileDialog} label="Открыть файл"/>
                                    </div>
                                )}
                            </DragNDropField>
                        </div>
                    </GridItem>
                </Grid>)}

            <div className="bsi-table-card">
                <div className="bsi-table-card__head">
                    <div>
                        <h2>{tabsValue?.name === "Загрузка"
                            ? 'Загруженные БСИ'
                            : tabsValue?.name === "Сервер"
                                ? 'БСИ с сервера'
                                : 'Автозагрузка БСИ'}</h2>
                        <p>{tabsValue?.name === "Загрузка"
                            ? 'История файлов, которые уже обработаны и доступны в системе'
                            : tabsValue?.name === "Сервер"
                                ? 'Данные, полученные напрямую с серверных устройств экипажей'
                                : 'Очередь сопоставления серверных БСИ со скважинами и графиком'}</p>
                    </div>
                    <Tabs
                        value={tabsValue}
                        size="s"
                        view="bordered"
                        linePosition="bottom"
                        fitMode="scroll"
                        onChange={({value}) => setTabsValue(value)}
                        items={items}
                        getItemLabel={(item) => item.name}
                    />
                </div>
                {tabsValue?.name === "Загрузка" &&
                    <GridBsiBsiList key="uploaded" newRowData={newRowData} fromUploaded={false}/>
                }
                {tabsValue?.name === "Сервер" &&
                    <>
                        <TehsmartServerPanel/>
                        <GridBsiBsiList key="server" newRowData={newRowData} fromUploaded={true}/>
                    </>
                }
                {tabsValue?.name === "Автозагрузка" &&
                    <AutoLoadPanel/>
                }
            </div>

            <ModalBsiPayload isOpen={isModalOpen}
                             onClose={handleModalClose}
                             files={files}
                             nodeData={null}/>
            {isModalDiagramOpen && (
                <ModalBsiDiagram isOpen={isModalDiagramOpen}
                                 onClose={handleModalDiagramClose}
                                 bsiFileDiagram={bsiFileDiagram}
                                 localFileName={bsiDiagramFileName}
                                 localFileReading={isDiagramFileReading}
                />
            )}

            {showSnackbar && processingData.length > 0 && (
                <SnackCmp
                    key={JSON.stringify(processingData)}
                    alertText={''}
                    processingData={processingData}
                    alertType={'normal'}
                />
            )}
        </div>
    )
}

function AutoLoadPanel() {
    const [orgs, setOrgs] = useState<any[]>([])
    const [error, setError] = useState('')
    const [actionMessage, setActionMessage] = useState('')
    const [loadingSessionId, setLoadingSessionId] = useState('')
    const [dateFrom, setDateFrom] = useState(() => {
        const value = new Date()
        value.setDate(value.getDate() - 1)
        return value.toISOString().slice(0, 10)
    })
    const [selectedOrg, setSelectedOrg] = useState('')
    const [autoDevices, setAutoDevices] = useState<any[]>([])
    const [deviceOptions, setDeviceOptions] = useState<any[]>([])
    const [selectedAutoDevice, setSelectedAutoDevice] = useState('')
    const [autoDevicesLoading, setAutoDevicesLoading] = useState(false)
    const [expandedAutoDevice, setExpandedAutoDevice] = useState('')
    const [autoDeviceSessions, setAutoDeviceSessions] = useState<Record<string, any[]>>({})
    const [autoDeviceSessionsLoading, setAutoDeviceSessionsLoading] = useState('')
    const [dailyRunning, setDailyRunning] = useState(false)
    const [sourceDiagramData, setSourceDiagramData] = useState<any>(null)
    const [sourceDiagramInfo, setSourceDiagramInfo] = useState('')
    const [sourceDiagramLoading, setSourceDiagramLoading] = useState(false)
    const [isSourceDiagramOpen, setIsSourceDiagramOpen] = useState(false)
    const [historyRows, setHistoryRows] = useState<any[]>([])
    const [historyLoading, setHistoryLoading] = useState(false)
    const [historyDateFrom, setHistoryDateFrom] = useState(() => {
        const value = new Date()
        value.setDate(value.getDate() - 14)
        return value.toISOString().slice(0, 10)
    })
    const [historyDateTo, setHistoryDateTo] = useState(() => new Date().toISOString().slice(0, 10))
    const [expandedHistoryGroups, setExpandedHistoryGroups] = useState<Record<string, boolean>>({})
    const isAdmin = localStorage.getItem('username') === 'admin'

    const fetchOrgs = async () => {
        try {
            const response = await http.get(API_CONTRACTOR_CLOSURE_OPTIONS)
            setOrgs(response.data?.orgs || [])
        } catch (err) {
            setOrgs([])
        }
    }

    const fetchAutoDevices = async () => {
        setAutoDevicesLoading(true)
        try {
            const response = await http.get(API_BSI_AUTO_DEVICES, {
                params: {
                    org: selectedOrg || undefined,
                },
            })
            setAutoDevices(response.data?.results || [])
            setDeviceOptions(response.data?.device_options || [])
        } catch (err: any) {
            setError(err.response?.data?.detail || 'Не удалось получить автоэкипажи')
        } finally {
            setAutoDevicesLoading(false)
        }
    }

    const addAutoDevice = async () => {
        if (!selectedAutoDevice) {
            setError('Выберите прибор для автозагрузки')
            return
        }
        setAutoDevicesLoading(true)
        setError('')
        try {
            await http.post(API_BSI_AUTO_DEVICES, {
                device: selectedAutoDevice,
                active: true,
            })
            setSelectedAutoDevice('')
            await fetchAutoDevices()
        } catch (err: any) {
            setError(err.response?.data?.detail || err.response?.data?.device?.[0] || 'Не удалось добавить автоэкипаж')
        } finally {
            setAutoDevicesLoading(false)
        }
    }

    const toggleAutoDevice = async (item: any) => {
        setAutoDevicesLoading(true)
        setError('')
        try {
            await http.patch(`${API_BSI_AUTO_DEVICES}${item.id}/`, {
                active: !item.active,
            })
            await fetchAutoDevices()
        } catch (err: any) {
            setError(err.response?.data?.detail || 'Не удалось изменить автоэкипаж')
        } finally {
            setAutoDevicesLoading(false)
        }
    }

    const deleteAutoDevice = async (item: any) => {
        setAutoDevicesLoading(true)
        setError('')
        try {
            await http.delete(`${API_BSI_AUTO_DEVICES}${item.id}/`)
            await fetchAutoDevices()
        } catch (err: any) {
            setError(err.response?.data?.detail || 'Не удалось удалить автоэкипаж')
        } finally {
            setAutoDevicesLoading(false)
        }
    }

    const toggleAutoDeviceSessions = async (item: any) => {
        if (expandedAutoDevice === item.id) {
            setExpandedAutoDevice('')
            return
        }
        setExpandedAutoDevice(item.id)
        if (autoDeviceSessions[item.id]) {
            return
        }
        await fetchAutoDeviceSessions(item)
    }

    const fetchAutoDeviceSessions = async (item: any) => {
        if (!item.device || !item.last_work_date) {
            setAutoDeviceSessions((prev) => ({...prev, [item.id]: []}))
            return
        }
        setAutoDeviceSessionsLoading(item.id)
        setError('')
        try {
            const response = await http.get(API_BSI_AUTO_SESSIONS, {
                params: {
                    date_from: item.last_work_date,
                    date_to: item.last_work_date,
                    device_id: item.device,
                    shift: 'ALL',
                    limit: 10000,
                },
            })
            setAutoDeviceSessions((prev) => ({
                ...prev,
                [item.id]: response.data?.results || [],
            }))
        } catch (err: any) {
            setError(err.response?.data?.detail || 'Не удалось открыть сессии автоэкипажа')
        } finally {
            setAutoDeviceSessionsLoading('')
        }
    }

    const fetchAutoHistory = async () => {
        setHistoryLoading(true)
        setError('')
        try {
            const response = await http.get(API_BSI_AUTO_SESSIONS, {
                params: {
                    date_from: historyDateFrom || undefined,
                    date_to: historyDateTo || undefined,
                    org: selectedOrg || undefined,
                    status: 'LOADED',
                    shift: 'ALL',
                    limit: 10000,
                },
            })
            setHistoryRows(response.data?.results || [])
            setExpandedHistoryGroups({})
        } catch (err: any) {
            setError(err.response?.data?.detail || 'Не удалось получить историю автозагрузки')
        } finally {
            setHistoryLoading(false)
        }
    }

    const updateAutoSessionRow = (updated: any) => {
        setAutoDeviceSessions((prev) => {
            const next = {...prev}
            Object.keys(next).forEach((key) => {
                next[key] = next[key].map((row: any) => row.id === updated.id ? updated : row)
            })
            return next
        })
        setHistoryRows((prev) => prev.map((row: any) => row.id === updated.id ? updated : row))
    }

    const runDailyAuto = async () => {
        setDailyRunning(true)
        setError('')
        try {
            const response = await http.post(API_BSI_AUTO_DAILY_RUN, {
                work_date: dateFrom || undefined,
            })
            pollDailyAutoTask(response.data.requestId)
        } catch (err: any) {
            setDailyRunning(false)
            setError(err.response?.data?.detail || 'Не удалось запустить ежедневную автозагрузку')
        }
    }

    const pollDailyAutoTask = async (requestId: string) => {
        try {
            const response = await http.get(API_DRAMATIQ_TASK_RESULT, {
                params: {requestId},
            })
            const task = response.data
            if (!task) {
                window.setTimeout(() => pollDailyAutoTask(requestId), 2000)
                return
            }
            if (task.status === 'ERROR') {
                setDailyRunning(false)
                setError(task.error || 'Ошибка ежедневной автозагрузки')
                return
            }
            if (task.status === 'DONE') {
                setDailyRunning(false)
                await fetchAutoDevices()
                await fetchAutoHistory()
                setAutoDeviceSessions({})
                return
            }
            window.setTimeout(() => pollDailyAutoTask(requestId), 2000)
        } catch (err: any) {
            setDailyRunning(false)
            setError(err.response?.data?.detail || 'Не удалось получить результат ежедневной автозагрузки')
        }
    }

    useEffect(() => {
        fetchOrgs()
        fetchAutoDevices()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const openSourceDiagram = async (item: any) => {
        setSourceDiagramLoading(true)
        setSourceDiagramData(null)
        setSourceDiagramInfo(`${item.equipage_name || 'Экипаж'} · ${formatDate(item.work_date)} · ${item.effective_well || item.source_well || 'Без номера'}`)
        setIsSourceDiagramOpen(true)
        try {
            const response = await http.get(API_BSI_AUTO_SOURCE_DIAGRAM, {
                params: {
                    device_id: item.device_id,
                    work_date: item.work_date,
                    source_deposit: item.source_deposit || '',
                    source_bush: item.source_bush || '',
                    source_well: item.source_well || '',
                    start_at: item.start_at || item.first_on_time || undefined,
                    end_at: item.end_at || item.last_on_time || undefined,
                },
            })
            setSourceDiagramData(response.data)
        } catch (err: any) {
            setError(err.response?.data?.detail || 'Не удалось открыть график БСИ')
            setIsSourceDiagramOpen(false)
        } finally {
            setSourceDiagramLoading(false)
        }
    }

    const loadAutoSession = async (item: any, force = false) => {
        setError('')
        setActionMessage('')
        setLoadingSessionId(item.id)
        try {
            const response = await http.post(`${API_BSI_AUTO_SESSION_LOAD}${item.id}/load/`, force ? {force: true} : {})
            const updated = response.data?.session
            const result = response.data?.result || {}
            if (updated) {
                updateAutoSessionRow(updated)
            }
            if (result.status === 'LOADED') {
                setActionMessage(`БСИ по скважине ${item.effective_well || item.source_well || 'без номера'} загружена в график.`)
                await fetchAutoHistory()
            } else {
                setError(result.reason || updated?.reason || 'БСИ не загружена: проверьте статус строки')
            }
        } catch (err: any) {
            setError(err.response?.data?.detail || 'Не удалось загрузить сессию в график')
        } finally {
            setLoadingSessionId('')
        }
    }

    const correctAutoSessionWell = async (item: any) => {
        setError('')
        setActionMessage('')
        const currentWell = item.corrected_well || item.source_well || ''
        const correctedWell = window.prompt('Укажите правильный номер скважины. Пустое значение сбросит исправление.', currentWell)
        if (correctedWell === null) {
            return
        }
        setLoadingSessionId(item.id)
        try {
            const response = await http.post(`${API_BSI_AUTO_SESSION_CORRECT_WELL}${item.id}/correct-well/`, {
                corrected_well: correctedWell.trim(),
            })
            const updated = response.data?.session
            if (updated) {
                updateAutoSessionRow(updated)
            }
            setActionMessage(`Номер скважины обновлен: ${updated?.effective_well || updated?.source_well || 'без номера'}.`)
        } catch (err: any) {
            setError(err.response?.data?.detail || 'Не удалось изменить номер скважины')
        } finally {
            setLoadingSessionId('')
        }
    }

    return (
        <div className="bsi-auto">
            <div className="bsi-auto__toolbar">
                <div>
                    <h3>Автозагрузка Tehsmart</h3>
                    <p>Включаем приборы, запускаем ежедневную загрузку и смотрим результат по конкретному автоэкипажу.</p>
                </div>
            </div>

            <div className="bsi-auto__filters">
                {isAdmin ? (
                    <label>
                        Подрядчик
                        <select
                            value={selectedOrg}
                            onChange={(event) => {
                                setSelectedOrg(event.target.value)
                                setHistoryRows([])
                                setExpandedHistoryGroups({})
                            }}
                        >
                            <option value="">Все подрядчики</option>
                            {orgs.map((org: any) => (
                                <option key={org.id} value={org.id}>{org.name}</option>
                            ))}
                        </select>
                    </label>
                ) : (
                    <div className="bsi-auto__scope-note">
                        Показана только техника вашей организации
                    </div>
                )}
                <label>
                    Дата автозагрузки
                    <input type="date" value={dateFrom} onChange={(event) => setDateFrom(event.target.value)}/>
                </label>
                <button type="button" onClick={fetchAutoDevices} disabled={autoDevicesLoading}>
                    {autoDevicesLoading ? 'Обновляем...' : 'Показать экипажи'}
                </button>
            </div>

            <div className="bsi-auto-devices">
                <div className="bsi-auto-devices__head">
                    <div>
                        <h3>Автоэкипажи</h3>
                        <p>Только эти приборы будут обрабатываться ежедневной автозагрузкой в окне 08:00-08:00.</p>
                    </div>
                    {isAdmin && (
                        <button type="button" className="bsi-auto__button bsi-auto__button--primary" onClick={runDailyAuto} disabled={dailyRunning || autoDevicesLoading}>
                            {dailyRunning ? 'Автозагрузка...' : 'Запустить за дату'}
                        </button>
                    )}
                </div>
                <div className="bsi-auto-devices__add">
                    {isAdmin && (
                        <>
                            <select value={selectedAutoDevice} onChange={(event) => setSelectedAutoDevice(event.target.value)}>
                                <option value="">Выберите прибор</option>
                                {deviceOptions.map((item: any) => (
                                    <option key={item.id} value={item.id} disabled={Boolean(item.auto_config_id)}>
                                        {item.label} · {item.equipage_name} · {item.org_name || 'без подрядчика'}{item.auto_config_id ? ' · уже добавлен' : ''}
                                    </option>
                                ))}
                            </select>
                            <button type="button" onClick={addAutoDevice} disabled={autoDevicesLoading || !selectedAutoDevice}>
                                Добавить экипаж
                            </button>
                        </>
                    )}
                    <button type="button" onClick={fetchAutoDevices} disabled={autoDevicesLoading}>
                        {autoDevicesLoading ? 'Обновляем...' : 'Обновить'}
                    </button>
                </div>
                <div className="bsi-auto-devices__table">
                    <div className="bsi-auto-devices__row bsi-auto-devices__row--head">
                        <span>Статус</span>
                        <span>Экипаж</span>
                        <span>Прибор</span>
                        <span>Подрядчик</span>
                        <span>Последний запуск</span>
                        <span>Результат</span>
                        <span>Действия</span>
                    </div>
                    {autoDevices.map((item: any) => (
                        <React.Fragment key={item.id}>
                            <div className={`bsi-auto-devices__row ${item.active ? 'is-active' : 'is-paused'}`}>
                                <span>{item.active ? 'Включен' : 'Выключен'}</span>
                                <span><strong>{item.equipage_name || 'Не привязан'}</strong></span>
                                <span>{item.device_name}</span>
                                <span>{item.org_name || '—'}</span>
                                <span>
                                    <strong>{item.last_status_display || 'Не запускался'}</strong>
                                    <small>{item.last_work_date ? formatDate(item.last_work_date) : '—'}</small>
                                </span>
                                <span title={item.last_error || ''}>
                                    <button type="button" className="bsi-auto-devices__result" onClick={() => toggleAutoDeviceSessions(item)}>
                                        <strong>{getAutoDeviceSessionCount(item, autoDeviceSessions)} сесс.</strong>
                                        <small>{item.last_error || `строк: ${item.last_result?.received ?? 0}`}</small>
                                    </button>
                                </span>
                                <span className="bsi-auto-devices__actions">
                                    {isAdmin ? (
                                        <>
                                            <button type="button" onClick={() => toggleAutoDevice(item)} disabled={autoDevicesLoading}>
                                                {item.active ? 'Выключить' : 'Включить'}
                                            </button>
                                            <button type="button" onClick={() => deleteAutoDevice(item)} disabled={autoDevicesLoading}>
                                                Удалить
                                            </button>
                                        </>
                                    ) : (
                                        <span className="bsi-auto-devices__readonly">Только просмотр</span>
                                    )}
                                </span>
                            </div>
                            {expandedAutoDevice === item.id && (
                                <AutoDeviceSessionsPanel
                                    rows={autoDeviceSessions[item.id] || []}
                                    loading={autoDeviceSessionsLoading === item.id}
                                    onOpenDiagram={openSourceDiagram}
                                    onLoadSession={loadAutoSession}
                                    onCorrectWell={correctAutoSessionWell}
                                    loadingSessionId={loadingSessionId}
                                    canCorrectWell={isAdmin}
                                />
                            )}
                        </React.Fragment>
                    ))}
                    {!autoDevicesLoading && autoDevices.length === 0 && (
                        <div className="bsi-auto-table__empty">Автоэкипажи еще не добавлены</div>
                    )}
                </div>
            </div>

            {error && <div className="tehsmart-error">{error}</div>}
            {actionMessage && <div className="tehsmart-note">{actionMessage}</div>}

            <AutoHistoryPanel
                rows={historyRows}
                loading={historyLoading}
                dateFrom={historyDateFrom}
                dateTo={historyDateTo}
                expandedGroups={expandedHistoryGroups}
                onDateFromChange={setHistoryDateFrom}
                onDateToChange={setHistoryDateTo}
                onRefresh={fetchAutoHistory}
                onToggleGroup={(key: string) => setExpandedHistoryGroups((prev) => ({...prev, [key]: !prev[key]}))}
                onOpenDiagram={openSourceDiagram}
            />

            {isSourceDiagramOpen && (
                <ModalBsiDiagram
                    isOpen={isSourceDiagramOpen}
                    onClose={() => setIsSourceDiagramOpen(false)}
                    diagramData={sourceDiagramData}
                    equipageInfo={sourceDiagramInfo}
                    localFileReading={sourceDiagramLoading}
                />
            )}
        </div>
    )
}

function AutoDeviceSessionsPanel({rows, loading, onOpenDiagram, onLoadSession, onCorrectWell, loadingSessionId, canCorrectWell}: any) {
    return (
        <div className="bsi-auto-device-sessions">
            <div className="bsi-auto-device-sessions__head">
                <strong>Найденные сессии последнего запуска</strong>
                <span>{loading ? 'Загружаем...' : `${rows.length} шт.`}</span>
            </div>
            <div className="bsi-auto-device-sessions__table">
                <div className="bsi-auto-device-sessions__row bsi-auto-device-sessions__row--head">
                    <span>Дата</span>
                    <span>Скважина</span>
                    <span>Куст</span>
                    <span>Месторождение</span>
                    <span>Глубина</span>
                    <span>Начало</span>
                    <span>Окончание</span>
                    <span>Строк</span>
                    <span>Интервал</span>
                    <span>Статус</span>
                    <span>Причина</span>
                    <span>Действие</span>
                </div>
                {rows.map((item: any) => {
                    const hasCorrectedWell = Boolean(item.corrected_well)
                    return (
                        <div key={item.id} className={`bsi-auto-device-sessions__row is-${String(item.status || '').toLowerCase()}`}>
                            <span>{formatDate(item.work_date)}</span>
                            <span title={item.correction_note || ''} className={hasCorrectedWell ? 'is-corrected-well' : ''}>
                                <strong>{item.effective_well || item.source_well || 'Без номера'}</strong>
                                {hasCorrectedWell && <em>изменен</em>}
                                {hasCorrectedWell && (
                                    <small>было: {item.source_well || 'без номера'}</small>
                                )}
                            </span>
                            <span>{item.source_bush || '—'}</span>
                            <span>{item.source_deposit || '—'}</span>
                            <span>{formatDepth(item.max_depth)}</span>
                            <span>{formatDateTime(item.start_at)}</span>
                            <span>{formatDateTime(item.end_at)}</span>
                            <span>{item.rows_count || 0}</span>
                            <span title={item.deposit_interval_reason || ''}>{formatDepositInterval(item)}</span>
                            <span>{item.status_display || item.status}</span>
                            <span title={[item.reason, item.correction_note].filter(Boolean).join('\n') || ''}>
                                {item.reason || item.correction_note || '—'}
                            </span>
                            <span>
                                <button type="button" className="bsi-auto-table__button" onClick={() => onOpenDiagram(item)}>
                                    График
                                </button>
                                {canCorrectWell && !['LOADED', 'FILE_CREATED'].includes(item.status) && (
                                    <button
                                        type="button"
                                        className="bsi-auto-table__button"
                                        disabled={loadingSessionId === item.id}
                                        onClick={() => onCorrectWell(item)}
                                    >
                                        Номер
                                    </button>
                                )}
                                {item.status === 'READY' && (
                                    <button
                                        type="button"
                                        className="bsi-auto-table__button bsi-auto-table__button--load"
                                        disabled={loadingSessionId === item.id}
                                        onClick={() => onLoadSession(item)}
                                    >
                                        {loadingSessionId === item.id ? 'Грузим...' : 'Загрузить'}
                                    </button>
                                )}
                                {!['READY', 'LOADED', 'FILE_CREATED'].includes(item.status) && (
                                    <button
                                        type="button"
                                        className="bsi-auto-table__button bsi-auto-table__button--force"
                                        title="Загрузить все равно"
                                        disabled={loadingSessionId === item.id}
                                        onClick={() => onLoadSession(item, true)}
                                    >
                                        {loadingSessionId === item.id ? 'Грузим...' : 'Все равно'}
                                    </button>
                                )}
                            </span>
                        </div>
                    )
                })}
                {!loading && rows.length === 0 && (
                    <div className="bsi-auto-table__empty">Для последнего запуска сессии не найдены</div>
                )}
            </div>
        </div>
    )
}

function getAutoDeviceSessionCount(item: any, sessionsByConfig: Record<string, any[]>) {
    if (Object.prototype.hasOwnProperty.call(sessionsByConfig, item.id)) {
        return sessionsByConfig[item.id]?.length || 0
    }
    return item.last_result?.sessions_total ?? 0
}

function AutoHistoryPanel({
    rows,
    loading,
    dateFrom,
    dateTo,
    expandedGroups,
    onDateFromChange,
    onDateToChange,
    onRefresh,
    onToggleGroup,
    onOpenDiagram,
}: any) {
    const groups = groupAutoHistory(rows)

    return (
        <div className="bsi-auto-history">
            <div className="bsi-auto-history__head">
                <div>
                    <h3>История автозагрузки</h3>
                    <p>Загруженные в график БСИ с группировкой по дням.</p>
                </div>
                <div className="bsi-auto-history__filters">
                    <label>
                        С
                        <input type="date" value={dateFrom} onChange={(event) => onDateFromChange(event.target.value)}/>
                    </label>
                    <label>
                        По
                        <input type="date" value={dateTo} onChange={(event) => onDateToChange(event.target.value)}/>
                    </label>
                    <button type="button" onClick={onRefresh} disabled={loading}>
                        {loading ? 'Загружаем...' : 'Показать историю'}
                    </button>
                </div>
            </div>

            {groups.length === 0 && (
                <div className="bsi-auto-table__empty">
                    {loading ? 'Загружаем историю...' : 'История автозагрузки за выбранный период не загружена или пуста'}
                </div>
            )}

            {groups.map((group: any) => (
                <div key={group.key} className="bsi-auto-history__group">
                    <button type="button" className="bsi-auto-history__group-head" onClick={() => onToggleGroup(group.key)}>
                        <span>{expandedGroups[group.key] ? '▾' : '▸'}</span>
                        <strong>{formatDate(group.workDate)}</strong>
                        <small>{group.rows.length} БСИ · {group.points} строк</small>
                    </button>
                    {expandedGroups[group.key] && (
                        <div className="bsi-auto-history__table">
                            <div className="bsi-auto-history__row bsi-auto-history__row--head">
                                <span>Подрядчик</span>
                                <span>Экипаж</span>
                                <span>Прибор</span>
                                <span>Куст</span>
                                <span>Скважина</span>
                                <span>Глубина</span>
                                <span>Интервал</span>
                                <span>Начало</span>
                                <span>Окончание</span>
                                <span>Статус</span>
                                <span>Действие</span>
                            </div>
                            {group.rows.map((item: any) => (
                                <div key={item.id} className="bsi-auto-history__row">
                                    <span>{item.org_name || '—'}</span>
                                    <span>{item.equipage_name || '—'}</span>
                                    <span>{item.device_name || '—'}</span>
                                    <span>{item.source_bush || '—'}</span>
                                    <span><strong>{item.source_well || 'Без номера'}</strong></span>
                                    <span>{formatDepth(item.max_depth)}</span>
                                    <span title={item.deposit_interval_reason || ''}>{formatDepositInterval(item)}</span>
                                    <span>{formatDateTime(item.start_at)}</span>
                                    <span>{formatDateTime(item.end_at)}</span>
                                    <span>{item.reason || item.status_display || item.status}</span>
                                    <span>
                                        <button type="button" className="bsi-auto-table__button" onClick={() => onOpenDiagram(item)}>
                                            График
                                        </button>
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ))}
        </div>
    )
}

function groupAutoHistory(rows: any[]) {
    const groups = rows.reduce((acc: any, item: any) => {
        const workDate = item.work_date || ''
        const key = workDate
        if (!acc[key]) {
            acc[key] = {
                key,
                workDate,
                rows: [],
                points: 0,
            }
        }
        acc[key].rows.push(item)
        acc[key].points += item.rows_count || 0
        return acc
    }, {})

    return Object.values(groups).sort((left: any, right: any) => {
        return String(right.workDate).localeCompare(String(left.workDate))
    })
}

function TehsmartServerPanel() {
    const [data, setData] = useState<any>(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [selectedDevice, setSelectedDevice] = useState<any>(null)
    const [archiveDate, setArchiveDate] = useState(() => new Date().toISOString().slice(0, 10))
    const [archiveData, setArchiveData] = useState<any>(null)
    const [archiveLoading, setArchiveLoading] = useState(false)
    const [archiveError, setArchiveError] = useState('')

    const rows = data?.results || []
    const totals = data?.totals || {}
    const groupedRows = groupBy(rows, 'token_org_name')

    const refreshStatus = async () => {
        setLoading(true)
        setError('')
        setData(null)
        try {
            const response = await http.post(API_BSI_TEHSMART_REFRESH)
            const requestId = response.data.requestId
            pollTask(requestId)
        } catch (err: any) {
            setLoading(false)
            setError(err.response?.data?.detail || 'Не удалось запустить обновление Tehsmart')
        }
    }

    const pollTask = async (requestId: string) => {
        try {
            const response = await http.get(API_DRAMATIQ_TASK_RESULT, {
                params: {requestId},
            })
            const task = response.data
            if (!task) {
                window.setTimeout(() => pollTask(requestId), 2000)
                return
            }
            if (task.status === 'ERROR') {
                setLoading(false)
                setError(task.error || 'Ошибка фоновой задачи Tehsmart')
                return
            }
            if (task.status === 'DONE') {
                setLoading(false)
                setData(task.data)
                return
            }
            window.setTimeout(() => pollTask(requestId), 2000)
        } catch (err: any) {
            setLoading(false)
            setError(err.response?.data?.detail || 'Не удалось получить результат обновления')
        }
    }

    const openArchive = async (device: any) => {
        setSelectedDevice(device)
        setArchiveData(null)
        setArchiveError('')
        setArchiveLoading(true)
        try {
            const response = await http.get(API_BSI_TEHSMART_ARCHIVE, {
                params: {
                    serialNo: device.serial_no,
                    date: archiveDate,
                    tokenOrgId: device.token_org_id,
                },
            })
            setArchiveData(response.data)
        } catch (err: any) {
            setArchiveError(err.response?.data?.error || 'Не удалось получить архив прибора')
        } finally {
            setArchiveLoading(false)
        }
    }

    useEffect(() => {
        if (selectedDevice) {
            openArchive(selectedDevice)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [archiveDate])

    return (
        <div className="tehsmart-panel">
            <div className="tehsmart-panel__head">
                <div>
                    <h3>Tehsmart Online</h3>
                    <p>Мониторинг приборов СКК-311 по подрядчикам. Архив загружается только при открытии прибора.</p>
                </div>
                <button type="button" onClick={refreshStatus} disabled={loading}>
                    {loading ? 'Обновляем...' : 'Обновить с Tehsmart'}
                </button>
            </div>

            {(data || loading || error) && (
                <div className="tehsmart-panel__body">
                    <div className="tehsmart-counters">
                        <TehsmartCounter label="Всего" value={totals.total || 0}/>
                        <TehsmartCounter label="На связи" value={totals.online || 0} accent="green"/>
                        <TehsmartCounter label="За сутки" value={totals.stale || 0} accent="yellow"/>
                        <TehsmartCounter label="Молчат" value={totals.silent || 0} accent="red"/>
                        <TehsmartCounter label="Нет в АСПО" value={totals.unknown_devices || 0} accent="blue"/>
                        <TehsmartCounter label="Не привязаны" value={totals.not_linked || 0} accent="gray"/>
                        <TehsmartCounter label="Server mode выкл." value={totals.server_mode_off || 0} accent="orange"/>
                    </div>

                    {loading && <div className="tehsmart-note">Обновляем данные Tehsmart...</div>}
                    {error && <div className="tehsmart-error">{error}</div>}
                    {data?.errors?.length > 0 && (
                        <div className="tehsmart-error">
                            {data.errors.map((item: any) => (
                                <span key={item.org_id}>{item.org_name}: {item.message}</span>
                            ))}
                        </div>
                    )}

                    {rows.length > 0 && (
                        <div className="tehsmart-groups">
                            {Object.entries(groupedRows).map(([orgName, items]: any) => (
                                <div key={orgName} className="tehsmart-group">
                                    <div className="tehsmart-group__head">
                                        <strong>{orgName}</strong>
                                        <span>{items.length}</span>
                                    </div>
                                    <div className="tehsmart-table">
                                        <div className="tehsmart-table__row tehsmart-table__row--head">
                                            <span>Прибор</span>
                                            <span>Экипаж</span>
                                            <span>Последний сигнал</span>
                                            <span>Глубина</span>
                                            <span>Статус</span>
                                            <span>АСПО</span>
                                        </div>
                                        {items.map((item: any) => (
                                            <button
                                                key={item.id}
                                                type="button"
                                                className={`tehsmart-table__row is-${String(item.status || '').toLowerCase()}`}
                                                onClick={() => openArchive(item)}
                                            >
                                                <span>{item.serial_no}</span>
                                                <span>{item.equipage_name || 'Не привязан'}</span>
                                                <span>{formatDateTime(item.last_on_time)}</span>
                                                <span>{formatDepth(item.depth)}</span>
                                                <span>{item.status_display}</span>
                                                <span>{item.is_known_device ? (item.equipage_server_mode ? 'server mode' : 'есть') : 'нет'}</span>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {selectedDevice && (
                <div className="tehsmart-modal-overlay" onClick={() => setSelectedDevice(null)}>
                    <div className="tehsmart-modal" onClick={(event) => event.stopPropagation()}>
                        <div className="tehsmart-modal__head">
                            <div>
                                <h3>Прибор {selectedDevice.serial_no}</h3>
                                <p>{selectedDevice.token_org_name} · {selectedDevice.equipage_name || 'экипаж не привязан'}</p>
                            </div>
                            <button type="button" onClick={() => setSelectedDevice(null)}>Закрыть</button>
                        </div>
                        <div className="tehsmart-modal__toolbar">
                            <label>
                                Дата архива
                                <input
                                    type="date"
                                    value={archiveDate}
                                    onChange={(event) => setArchiveDate(event.target.value)}
                                />
                            </label>
                            <button type="button" onClick={() => openArchive(selectedDevice)} disabled={archiveLoading}>
                                {archiveLoading ? 'Загружаем...' : 'Обновить день'}
                            </button>
                        </div>
                        {archiveError && <div className="tehsmart-error">{archiveError}</div>}
                        {archiveLoading && <div className="tehsmart-note">Загружаем архив прибора...</div>}
                        {archiveData && (
                            <div className="tehsmart-archive">
                                <div className="tehsmart-archive__summary">
                                    <TehsmartInfo label="Строк" value={archiveData.summary?.rows_total}/>
                                    <TehsmartInfo label="Макс. глубина" value={formatDepth(archiveData.summary?.max_depth)}/>
                                    <TehsmartInfo label="Месторождение" value={archiveData.summary?.area || '—'}/>
                                    <TehsmartInfo label="Куст" value={archiveData.summary?.bush || '—'}/>
                                    <TehsmartInfo label="Скважина" value={archiveData.summary?.well || '—'}/>
                                    <TehsmartInfo label="Ответственный" value={archiveData.summary?.people || '—'}/>
                                </div>
                                <DepthChart points={archiveData.points || []}/>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}

function TehsmartCounter({label, value, accent = ''}: any) {
    return (
        <div className={`tehsmart-counter ${accent ? `is-${accent}` : ''}`}>
            <span>{label}</span>
            <strong>{value}</strong>
        </div>
    )
}

function TehsmartInfo({label, value}: any) {
    return (
        <div className="tehsmart-info">
            <span>{label}</span>
            <strong>{value ?? '—'}</strong>
        </div>
    )
}

function DepthChart({points}: any) {
    const cleanPoints = (points || [])
        .map((item: any) => ({...item, depth: normalizeDepth(item.depth)}))
        .filter((item: any) => typeof item.depth === 'number')
    if (cleanPoints.length < 2) {
        return <div className="tehsmart-chart tehsmart-chart--empty">Недостаточно точек для графика</div>
    }
    const width = 900
    const height = 220
    const maxDepth = Math.max(...cleanPoints.map((item: any) => item.depth || 0), 1)
    const linePoints = cleanPoints.map((item: any, index: number) => {
        const x = (index / (cleanPoints.length - 1)) * width
        const y = height - ((item.depth || 0) / maxDepth) * (height - 20) - 10
        return `${x.toFixed(1)},${y.toFixed(1)}`
    }).join(' ')

    return (
        <div className="tehsmart-chart">
            <div className="tehsmart-chart__head">
                <strong>Глубина</strong>
                <span>макс. {formatDepth(maxDepth)} м · точек {cleanPoints.length}</span>
            </div>
            <svg viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none">
                <polyline points={linePoints} fill="none" stroke="#175cd3" strokeWidth="3"/>
            </svg>
        </div>
    )
}

function groupBy(rows: any[], key: string) {
    return rows.reduce((acc: any, item: any) => {
        const groupKey = item[key] || 'Без группы'
        if (!acc[groupKey]) acc[groupKey] = []
        acc[groupKey].push(item)
        return acc
    }, {})
}

function formatDateTime(value: string | null) {
    if (!value) return '—'
    return new Date(value).toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    })
}

function formatDate(value: string | null) {
    if (!value) return '—'
    return new Date(value).toLocaleDateString('ru-RU')
}

function normalizeDepth(value: any) {
    if (value === null || value === undefined || value === '') return null
    const numberValue = Number(value)
    if (Number.isNaN(numberValue)) return null
    return Math.abs(numberValue) >= 10000 ? numberValue / 100 : numberValue
}

function formatDepth(value: any) {
    const depth = normalizeDepth(value)
    if (depth === null) return '—'
    return depth.toFixed(depth % 1 === 0 ? 0 : 2)
}

function formatDepositInterval(item: any) {
    const start = item.deposit_interval_start
    const end = item.deposit_interval_end
    if (start === null || start === undefined || end === null || end === undefined) {
        return '—'
    }
    return `${start}-${end}`
}

export default PageBsi;
